import type { UserResponse } from "libs/apiClient";
import { Permission, Resource } from "pages/productManagement/types";
import { isProviderOperationsEnabled } from "./isProviderOperationsEnabled";

export function hasProviderOperationsPermission(user: UserResponse): boolean {
	const permissions = user.permissions ?? [];

	return permissions.some(
		(entry) => entry.resource === Resource.PROVIDER_OPERATIONS && entry.permission === Permission.EDIT,
	);
}

export function hasProviderOperationsAccess(user: UserResponse): boolean {
	if (isProviderOperationsEnabled() === false) {
		return false;
	}

	return hasProviderOperationsPermission(user);
}
